import type { Catalog } from '..'

export const workspace: Catalog['workspace'] = {
  planActive: 'O plano Team está ativo — boas-vindas',
  checkoutCanceled: 'Checkout cancelado — nada foi cobrado',
  needsPlan: '"{name}" precisa de um plano primeiro.',
  thisWorkspace: 'Este workspace',
  notFound: 'Workspace não encontrado',
  notFoundBody: 'Ele pode ter sido excluído, ou você não é mais membro.',
  backToCanvases: 'Voltar aos canvases',
  workspace: 'Workspace',
  people: 'Pessoas',
  planBilling: 'Plano e cobrança',
  billing: 'Cobrança',
  general: 'Geral',
  breadcrumb: 'Trilha de navegação',
  home: 'Início',
  memberCount: { one: '{count} pessoa', other: '{count} pessoas' },
  canvasCount: { one: '{count} canvas', other: '{count} canvases' },
  selfHostedIncluded: 'Auto-hospedado, incluído',
  noPlanYet: 'Ainda sem plano.',
  noPlanBody: 'Convidar pessoas e adicionar canvases fica para quando este workspace estiver no Team.',
  canceledBody: ' Os canvases existentes continuam abertos para todos que estão nele.',
  reactivate: 'Reativar',
  choosePlan: 'Escolher um plano',
  paymentFailed: 'O último pagamento falhou.',
  paymentFailedBody: 'O Stripe está tentando de novo; atualize o cartão no portal de cobrança para manter o plano.',

  statusInactive: 'Ainda sem plano',
  statusTrialing: 'Teste',
  statusActive: 'Ativo',
  statusPastDue: 'Pagamento falhou',
  statusCanceled: 'Cancelado',

  invitedMember: '{name} entrou',
  inviteEmailed: 'Convite enviado por e-mail para {email}',
  invitePending: '{email} entra quando se cadastrar com esse e-mail',
  inviteFailed: 'Não foi possível convidar',
  roleChangeFailed: 'Não foi possível mudar o papel',
  removeFailed: 'Não foi possível remover',
  revokeFailed: 'Não foi possível revogar o convite',
  peopleDescription:
    'Todos aqui abrem todos os canvases do workspace. Admins convidam e removem pessoas; o dono cuida da cobrança.',
  oneSeatEach: ' Cada pessoa ocupa um assento.',
  inviteByEmail: 'Convidar por e-mail',
  emailToInvite: 'E-mail para convidar',
  role: 'Papel',
  inviting: 'Convidando…',
  invite: 'Convidar',
  roleOwner: 'dono',
  roleAdmin: 'admin',
  roleMember: 'membro',
  roleOf: 'Papel de {name}',
  leave: 'Sair',
  remove: 'Remover',
  you: '{name} (você)',
  emailJoined: '{email} · entrou {time}',
  waitingToSignUp: 'Aguardando cadastro',
  invitedBy: '· {role} · convidado por {name}',
  revoke: 'Revogar',
  leaveTitle: 'Sair de “{name}”?',
  removeTitle: 'Remover {name}?',
  leaveDescription: 'Você perde o acesso a todos os canvases deste workspace, exceto os seus.',
  removeDescription:
    'A pessoa perde o acesso a todos os canvases deste workspace, exceto os dela. O assento dela é liberado.',
  leaveWorkspace: 'Sair do workspace',
  member: 'Membro',
  admin: 'Admin',

  portalFailed: 'Não foi possível abrir o portal de cobrança',
  upToDate: 'Sincronizado com o Stripe',
  refreshFailed: 'Não foi possível atualizar',
  billingDescription:
    'O Team é cobrado por assento: cada pessoa no workspace, mensal ou anualmente. Os assentos acompanham a lista de pessoas — adicione alguém e a próxima fatura aumenta, remova e ela diminui.',
  billingDisabledDescription:
    'A cobrança não está configurada neste servidor. Workspaces estão incluídos no doop auto-hospedado; não há nada a pagar aqui.',
  plan: 'Plano',
  planTeam: 'Team',
  planPersonal: 'Pessoal',
  planSelfHosted: 'Auto-hospedado',
  endsOn: 'termina em {date}',
  seats: 'Assentos',
  seatsMath: '{seats} × {price} =',
  perMonth: 'por mês',
  perYear: 'por ano',
  seatsCatchUp: {
    one: '({count} pessoa agora — o Stripe se ajusta na próxima fatura)',
    other: '({count} pessoas agora — o Stripe se ajusta na próxima fatura)',
  },
  ends: 'Termina',
  renews: 'Renova',
  manage: 'Gerenciar',
  reactivateTeam: 'Reativar no Team',
  opening: 'Abrindo…',
  manageOnStripe: 'Gerenciar cobrança no Stripe',
  refresh: 'Atualizar',
  stripePortalNote: 'Cartões, faturas, cancelamento — tudo no portal do Stripe.',
  ownerHoldsBilling: 'O dono cuida da cobrança; só ele pode mudar o plano.',

  renamed: 'Renomeado',
  renameFailed: 'Não foi possível renomear',
  deleteFailed: 'Não foi possível excluir o workspace',
  generalDescription: 'O nome que todos veem na barra lateral e nos canvases arquivados aqui.',
  name: 'Nome',
  workspaceName: 'Nome do workspace',
  created: 'Criado',
  deleteWorkspace: 'Excluir workspace',
  deleteDescription:
    'Cada canvas volta para o espaço pessoal de quem é dono dele — nada é excluído. As pessoas perdem o acesso aos canvases que não são delas.',
  deleteCancelsTeam: ' A assinatura do Team é cancelada imediatamente.',
  deleteNamed: 'Excluir “{name}”',
  deleteTitle: 'Excluir “{name}”?',
  deleteConfirmDescription: 'Os canvases voltam aos donos e a assinatura termina agora. Isso não pode ser desfeito.',

  codexManual: 'Rode isto em um terminal com o Codex CLI instalado:',
  codexAdding: 'Adicionando o Doop…',
  codexAdded: 'Adicionado ao Codex',
  codexAdd: 'Adicionar ao Codex',
  codexConfigured: 'O Doop está configurado. Abra um novo chat do Codex e entre no Doop quando for solicitado.',
  codexUpdateDesktop: 'Atualize o Doop Desktop para adicionar o Codex direto, ou use a configuração manual abaixo.',
  openDesktop: 'Abrir o Doop Desktop',
  codexNeedsDesktop:
    'Requer o app desktop do Doop atualizado. Clique em Adicionar ao Codex lá para concluir. Se o app não abrir, use a configuração manual abaixo.',

  claudeOpening: 'Abrindo o Claude…',
  claudeOpenAgain: 'Abrir o Claude de novo',
  claudeAdd: 'Adicionar ao Claude',
  claudeNeedsDesktop:
    'Abra este servidor em um app desktop do Doop atualizado para adicionar o Claude direto. No navegador, você pode usar a instalação manual abaixo.',
  claudeConfirm: 'Confirme a instalação no Claude e depois aprove o login no Doop.',
  installManually: 'Instalar manualmente',
  downloadExtension: 'Baixe a extensão',
  claudeManualOpen: ' e abra com o Claude Desktop. Defina',
  claudeManualTo: 'como',
  claudeManualFallback: '. Se o arquivo não abrir, use no Claude',

  cursorAdd: 'Adicionar ao Cursor',
  connectionHelp: 'Ajuda com a conexão',
  cursorHelpBefore: 'Se o Cursor não abrir, abra o painel',
  cursorHelpMiddle: 'e adicione um servidor MCP personalizado. Mescle a entrada',
  cursorHelpAfter:
    'na sua configuração MCP, mantendo os servidores existentes. Se o Doop já estiver conectado por um plugin, use essa conexão.',
}
